//会员api
import request from "@/utils/request";

export const url = {
  member_list: "/api/MemberInfo/GetList",
  member_info: "/api/MemberInfo/GetDetail",
  member_del: "/api/MemberInfo/Delete",
  member_add: "/api/MemberInfo/Add",
  member_edit: "/api/MemberInfo/Update", //修改会员列表
  member_statusUpdate: "/api/MemberInfo/UpdateStatus", //修改会员状态
  Member_passwordUpdate: "/api/MemberInfo/UpdatePassword", //更新密码
  memberType_list: "/api/MemberCardType/GetMemberCardTypePageList",
  memberType_info: "/api/MemberCardType/GetMemberCardTypeById",
  member_index: "api/MemberInfo/MemberStatistics",
  member_recharge: "/api/MemberInfo/Recharge",
  member_passwordVerif: "/api/MemberInfo/VerificationPassword",
  member_consume: "/api/MemberInfo/Consume",
  member_accountRecord: "/api/MemberInfo/GetAccountRecordList",
};

export function getMemberIndex(data) {
  return request({
    url: url.member_index,
    method: "post",
    data: data,
  });
}

export function getMemberList(data) {
  return request({
    url: url.member_list,
    method: "post",
    data: data,
  });
}

export function getMemberInfo(data) {
  return request({
    url: url.member_info,
    method: "post",
    data: data,
  });
}

export function getMemberTypeList(data) {
  return request({
    url: url.memberType_list,
    method: "post",
    data: data,
  });
}

export function addMember(data) {
  return request({
    url: url.member_add,
    method: "post",
    data: data,
  });
}
export function editMember(data) {
  return request({
    url: url.member_edit,
    method: "post",
    data: data,
  });
}
export function updateStatus(data) {
  return request({
    url: url.member_statusUpdate,
    method: "post",
    data: data,
  });
}
export function delMember(data) {
  return request({
    url: url.member_del,
    method: "post",
    data: data,
  });
}

export function getMemberTypeInfo(data) {
  return request({
    url: url.memberType_info,
    method: "post",
    data: data,
  });
}

export function memberRecharge(data) {
  return request({
    url: url.member_recharge,
    method: "post",
    data: data,
  });
}

export function memberPasswordUpdate(data) {
  return request({
    url: url.Member_passwordUpdate,
    method: "post",
    data: data,
  });
}

export function memberPasswordVerif(data) {
  return request({
    url: url.member_passwordVerif,
    method: "post",
    data: data,
  });
}

export function memberConsume(data) {
  return request({
    url: url.member_consume,
    method: "post",
    data: data,
  });
}

export function getMemberAccountRecord(data) {
  return request({
    url: url.member_accountRecord,
    method: "post",
    data: data,
  });
}
